import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import { close as closeAction } from '../../features/alertSystem/actions';
import { getAlert, getIsOpen } from '../../features/alertSystem/selectors';
import { toJS } from '../../utils/immutableUtils';

const useStyles = makeStyles({
  spacer: {
    flexGrow: 1
  }
});

const Alert = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isOpen = useSelector(getIsOpen);
  const alert = toJS(useSelector(getAlert));
  const close = () => {
    dispatch(closeAction());
  };

  if (!alert) {
    return null;
  }

  return (
    <Dialog open={isOpen} onClose={close}>
      {alert.title && <DialogTitle>{alert.title}</DialogTitle>}
      {alert.content && (
        <DialogContent>
          <DialogContentText component="div">{alert.content}</DialogContentText>
        </DialogContent>
      )}
      {alert.actions && (
        <>
          <Divider />
          <DialogActions>
            {alert.actions.left}
            <div className={classes.spacer} />
            {alert.actions.right}
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default Alert;
